export default {
	GET_ALL: (crewId) => `/split/group/all?crewId=${crewId}`,
	GET_BY_SHORT_ID: (shortId) => `/split/group/short/${shortId}`,
	GET_BY_ID: (groupId) => `/split/group/${groupId}`,
	CREATE: (crewId) => `/split/group?crewId=${crewId}`,
	UPDATE: () => "/split/group",
	DELETE: (groupId) => `/split/group/${groupId}`,
};
